module.exports = __webpack_public_path__ + "static/img/3.602bfcc5.png";